/**
 * Betinovio (slot-pragmatic_tmp) game-code -> display name mapping.
 * Provider: Pragmatic (surfaced to users as "Pragmatic Play").
 * Auto-generated from betinovio_tmp_games.js. Total games: 681.
 */

const betinovioGameNameMapping = {
  "vs20wildparty_tmp": "3 Buzzing Wilds",
  "vswaysmonkey_tmp": "3 Dancing Monkeys",
  "vs50aladdin_tmp": "3 Genie Wishes",
  "vs25kingdoms_tmp": "3 Kingdoms - Battle of Red Cliffs",
  "vs25wolfgmm_tmp": "3 Magic Eggs",
  "vswayscharms_tmp": "5 Frozen Charms Megaways",
  "vs243lions_tmp": "5 Lions",
  "vs1024lionsd_tmp": "5 Lions Dance",
  "vs243lionsgold_tmp": "5 Lions Gold",
  "vswayslions_tmp": "5 Lions Megaways",
  "vsways5lions2_tmp": "5 Lions Megaways 2",
  "vsways5lionsr_tmp": "5 Lions Reborn",
  "vswaysrabbits_tmp": "5 Rabbits Megaways",
  "vs5magicdoor_tmp": "6 Jokers",
  "vswayssevenc_tmp": "7 Clovers of Fortune",
  "vs7monkeys_tmp": "7 Monkeys",
  "vs7pigs_tmp": "7 Piggies",
  "vs5t8goldfp_tmp": "777 Rush",
  "vs20eightdragons_tmp": "8 Dragons",
  "vs10gdchalleng_tmp": "8 Golden Dragon Challenge",
  "vs243goldfor_tmp": "888 Bonanza",
  "vs1dragon8_tmp": "888 Dragons",
  "vs20hotzone_tmp": "African Elephant",
  "vs20aladdinsorc_tmp": "Aladdin and the Sorcerer",
  "vs20alieninv_tmp": "Alien Invaders",
  "vs10amm_tmp": "Amazing Money Machine",
  "vswaysacnd_tmp": "Anaconda Gold",
  "vs10egypt_tmp": "Ancient Egypt",
  "vs10egyptcls_tmp": "Ancient Egypt Classic",
  "vswaysmodfr_tmp": "Ancient Island Megaways",
  "vs15fghtmultlv_tmp": "Angel vs Sinner",
  "vswaysanime_tmp": "Anime Mecha Megaways",
  "vswaysargonts_tmp": "Argonauts",
  "vs25asgard_tmp": "Asgard",
  "vs25kfruit_tmp": "Aztec Blaze",
  "vs7776aztec_tmp": "Aztec Bonanza",
  "vs5aztecgems_tmp": "Aztec Gems",
  "vs9aztecgemsdx_tmp": "Aztec Gems Deluxe",
  "vswaysaztec_tmp": "Aztec Gems Megaways",
  "vs25aztecking_tmp": "Aztec King",
  "vswaysaztecking_tmp": "Aztec King Megaways",
  "vs20sbpnudge_tmp": "Aztec Powernudge",
  "vs20plsmcannon_tmp": "Aztec Smash",
  "vs7776secrets_tmp": "Aztec Treasure",
  "vs20trswild3_tmp": "Aztec Treasure Hunt",
  "vs25badge_tmp": "Badge Blitz",
  "vs5balidragon_tmp": "Bali Dragon",
  "vswaysbandit_tmp": "Bandit Megaways",
  "vs20farmfest_tmp": "Barn Festival",
  "vswaysmegahays_tmp": "Barnyard Megahays Megaways",
  "vs20bigbbear_tmp": "Bear Crazy",
  "vs10beekeep_tmp": "Bee Keeper",
  "vs20bermuda_tmp": "Bermuda Riches",
  "vswaysbewaretd_tmp": "Beware The Deep Megaways",
  "vs10bbhas_tmp": "Big Bass - Hold & Spinner",
  "vs10bblotgl_tmp": "Big Bass - Secrets of the Golden Lake",
  "vs10bbextreme_tmp": "Big Bass Amazon Xtreme",
  "vs10bbbonanza_tmp": "Big Bass Bonanza",
  "vs10bbkir_tmp": "Big Bass Bonanza - Keeping it Reel",
  "vs10bbbrlact_tmp": "Big Bass Bonanza - Reel Action",
  "vs10bbbnz1000_tmp": "Big Bass Bonanza 1000",
  "vs5bb3reeler_tmp": "Big Bass Bonanza 3 Reeler",
  "vswaysbbb_tmp": "Big Bass Bonanza Megaways",
  "vs10bbbbrnd_tmp": "Big Bass Boxing Bonus Round",
  "vs10bbsplxmas_tmp": "Big Bass Christmas Bash",
  "vs10bbglxmas_tmp": "Big Bass Christmas – Frozen Lake",
  "vs10bbbnz_tmp": "Big Bass Day at the Races",
  "vs10bbdice_tmp": "Big Bass Dice",
  "vs10bbfloats_tmp": "Big Bass Floats my Boat",
  "vs10bbwcup_tmp": "Big Bass Football Bonanza",
  "vs10bhallbnza_tmp": "Big Bass Halloween",
  "vs10bhallbnza2_tmp": "Big Bass Halloween 2",
  "vs10bhallbnza3_tmp": "Big Bass Halloween 3",
  "vswaysbbhas_tmp": "Big Bass Hold & Spinner Megaways",
  "vs10bbfmission_tmp": "Big Bass Mission Fishin'",
  "vs10bbrcdr_tmp": "Big Bass Raceday Repeat",
  "vs10bbrrp_tmp": "Big Bass Reel Repeat",
  "vs10bbrttr_tmp": "Big Bass Return to the Races",
  "vs10txbigbass_tmp": "Big Bass Splash",
  "vs10bbsplashx_tmp": "Big Bass Splash 1000",
  "vs10bbtrphfshn_tmp": "Big Bass Trophy Catch",
  "vs10bbdoubled_tmp": "Big Bass Vegas Double Down Delux",
  "vs10bbxext_tmp": "Big Bass Xmas Extreme",
  "vs10bburger_tmp": "Big Burger Load it up with Xtra Cheese",
  "vs40bigjuan_tmp": "Big Juan",
  "vswaysbbarnh_tmp": "Bigger Barn House Bonanza",
  "vs12bbbxmas_tmp": "Bigger Bass Blizzard - Christmas Catch",
  "vs12bbb_tmp": "Bigger Bass Bonanza",
  "vs12bgrbspl_tmp": "Bigger Bass Splash",
  "vs30bingomania_tmp": "Bingo Mania",
  "vs20trswild2_tmp": "Black Bull",
  "vs20mergedwndw_tmp": "Blade & Fangs",
  "vswaysfirewmw_tmp": "Blazing Wilds Megaways",
  "vs20lightblitz_tmp": "Blitz Super Wheel",
  "vswayswildb_tmp": "Bloody Dawn",
  "vs25bomb_tmp": "Bomb Bonanza",
  "vs20bonzgold_tmp": "Bonanza Gold",
  "vs10bookazteck_tmp": "Book of Aztec King",
  "vs10bookfallen_tmp": "Book of Fallen",
  "vswaysbook_tmp": "Book of Golden Sands",
  "vs25bkofkngdm_tmp": "Book Of Kingdoms",
  "vs20fatbook_tmp": "Book of Monsters",
  "vs10bookoftut_tmp": "Book of Tut",
  "vswaystut_tmp": "Book of Tut Megaways",
  "vs10tut_tmp": "Book Of Tut Respin",
  "vs25btygold_tmp": "Bounty Gold",
  "vs20bhunter_tmp": "Bounty Hunter",
  "vs20gembondx_tmp": "Bow of Artemis",
  "vswaysbrickhos_tmp": "Brick House Bonanza",
  "vs10bblpop_tmp": "Bubble Pop",
  "vs4096bufking_tmp": "Buffalo King",
  "vswaysbufking_tmp": "Buffalo King Megaways",
  "vswaysbkingasc_tmp": "Buffalo King Untamed Megaways",
  "vs25bullfiesta_tmp": "Bull Fiesta",
  "vs20bl_tmp": "Busy Bees",
  "vs243caishien_tmp": "Caishen's Cash",
  "vs243fortune_tmp": "Caishen's Gold",
  "vsways4ptgld_tmp": "Caishen’s Cash Pots",
  "vs20candyblitz_tmp": "Candy Blitz",
  "vs20candybltz2_tmp": "Candy Blitz Bombs",
  "vs20fourmc_tmp": "Candy Corner",
  "vs20cjcluster_tmp": "Candy Jar Clusters",
  "vs20candyia_tmp": "Candy Rush",
  "vswaysstrwild_tmp": "Candy Stars",
  "vs20candvil_tmp": "Candy Village",
  "vswayschilhtwo_tmp": "Captain Kraken Megaways",
  "vswaysbankbonz_tmp": "Cash Bonanza",
  "vs20cashmachine_tmp": "Cash Box",
  "vs20maskgame_tmp": "Cash Chips",
  "vs20terrorv_tmp": "Cash Elevator",
  "vs25copsrobbers_tmp": "Cash Patrol",
  "vswayscashsurg_tmp": "Cash Surge",
  "vswayscheist_tmp": "Casino Heist Megaways",
  "vswaysexpandng_tmp": "Castle of Fire",
  "vswayscfglory_tmp": "Chase For Glory",
  "vs243ckemp_tmp": "Cheeky Emperor",
  "vs25checaishen_tmp": "Chests of Cai Shen",
  "vs25caishen2_tmp": "Chests of Cai Shen 2",
  "vs20chickdrop_tmp": "Chicken Drop",
  "vs25chilli_tmp": "Chilli Heat",
  "vswayschilheat_tmp": "Chilli Heat Megaways",
  "vs10chillihmr_tmp": "Chilli Heat Spicy Spins",
  "vs10bxmasbnza_tmp": "Christmas Big Bass Bonanza",
  "vs20xmascarol_tmp": "Christmas Carol Megaways",
  "vs20cleocatra_tmp": "Cleocatra",
  "vs20mustanggld2_tmp": "Clover Gold",
  "vs12tropicana_tmp": "Club Tropicana",
  "vs12trpcnhour_tmp": "Club Tropicana – Happy Hour",
  "vs5spjokfp_tmp": "Code of Cairo",
  "vs10coffee_tmp": "Coffee Wild",
  "vs20colcashzone_tmp": "Colossal Cash Zone",
  "vs432congocash_tmp": "Congo Cash",
  "vswayscongcash_tmp": "Congo Cash XL",
  "vs40cosmiccash_tmp": "Cosmic Cash",
  "vswaysultrcoin_tmp": "Cowboy Coins",
  "vs10cowgold_tmp": "Cowboys Gold",
  "vs20crankit_tmp": "Crank it Up",
  "vs10crownfire_tmp": "Crown of Fire",
  "vswayscryscav_tmp": "Crystal Caverns Megaways",
  "vs25scolymp_tmp": "CULT",
  "vswayswerewolf_tmp": "Curse of the Werewolf Megaways",
  "vs20cbrhst_tmp": "Cyber Heist",
  "vswayscypup_tmp": "Cyber Pup Megaways™",
  "vswayscyhecity_tmp": "Cyberheist City",
  "vs20earthquake_tmp": "Cyclops Smash",
  "vs25davinci_tmp": "Da Vinci's Treasure",
  "vs243dancingpar_tmp": "Dance Party",
  "vs20daydead_tmp": "Day of Dead",
  "vs40demonpots_tmp": "Demon Pots",
  "vs13g_tmp": "Devil's 13",
  "vs20devilic_tmp": "Devilicious",
  "vs50dmdcascade_tmp": "Diamond Cascade",
  "vs15diamond_tmp": "Diamond Strike",
  "vswayseternity_tmp": "Diamonds of Egypt",
  "vs10ddcbells_tmp": "Ding Dong Christmas Bells",
  "vs5tdragresk_tmp": "Dino Drop",
  "vs243discolady_tmp": "Disco Lady",
  "vs10djneko_tmp": "DJ Neko",
  "vs20underground_tmp": "Down the Rails",
  "vs1600drago_tmp": "Drago - Jewels of Fortune",
  "vs10dgold88_tmp": "Dragon Gold 88",
  "vs20drgbless_tmp": "Dragon Hero",
  "vs5drhs_tmp": "Dragon Hot Hold & Spin",
  "vs10dkinghp_tmp": "Dragon King Hot Pots",
  "vs25dragonkingdom_tmp": "Dragon Kingdom",
  "vs5drmystery_tmp": "Dragon Kingdom - Eyes of Fire",
  "vswaysdragden_tmp": "Dragon Pots Megaways",
  "vswayshuffpbh_tmp": "Dragon Tiger Fortunes",
  "vs50dragatebch_tmp": "Dragon’s Gate – Bonus Choice",
  "vs20drtgold_tmp": "Drill That Gold",
  "vswaysyinyang_tmp": "Duel of Night & Day",
  "vswaysspltsym_tmp": "Dwarf & Dragon",
  "vs25dwarves_new_tmp": "Dwarven Gold Deluxe",
  "vs10dyndigd_tmp": "Dynamite Diggin Doug",
  "vs20egypttrs_tmp": "Egyptian Fortunes",
  "vswayselements_tmp": "Elemental Gems Megaways",
  "vs20eking_tmp": "Emerald King",
  "vs20ekingrr_tmp": "Emerald King Rainbow Road",
  "vs10dublin_tmp": "Emerald King – Wheel of Wealth",
  "vs10emotiwins_tmp": "Emotiwins",
  "vs243empcaishen_tmp": "Emperor Caishen",
  "vs20emptybank_tmp": "Empty the Bank",
  "vs10fireice_tmp": "Escape the Pyramid – Fire & Ice",
  "vswaysfreezet_tmp": "Eternal Empress - Freeze Time",
  "vs20excalibur_tmp": "Excalibur Unleashed",
  "vs10fruity2_tmp": "Extra Juicy",
  "vswaysxjuicy_tmp": "Extra Juicy Megaways",
  "vs40cleoeye_tmp": "Eye of Cleopatra",
  "vs15eyeofspart_tmp": "Eye of Spartacus",
  "vs10eyestorm_tmp": "Eye of the Storm",
  "vs15fairytale_tmp": "Fairytale Fortune",
  "vs10fangfree_tmp": "Fangtastic Freespins",
  "vs20beefed_tmp": "Fat Panda",
  "vs10gbseries_tmp": "Fiesta Fortune",
  "vs10fingerlfs_tmp": "Finger Lick’n Free Spins",
  "vs7fire88_tmp": "Fire 88",
  "vs25archer_tmp": "Fire Archer",
  "vs100firehot_tmp": "Fire Hot 100",
  "vs20fh_tmp": "Fire Hot 20",
  "vs40firehot_tmp": "Fire Hot 40",
  "vs5firehot_tmp": "Fire Hot 5",
  "vs20portals_tmp": "Fire Portals",
  "vswaysstampede_tmp": "Fire Stampede",
  "vswaysfirest2_tmp": "Fire Stampede 2",
  "vs10firestrike_tmp": "Fire Strike",
  "vs10firestrike2_tmp": "Fire Strike 2",
  "vswaysconcoll_tmp": "Firebird Spirit - Connect & Collect",
  "vs10fisheye_tmp": "Fish Eye",
  "vs10goldfish_tmp": "Fishin Reels",
  "vs10floatdrg_tmp": "Floating Dragon",
  "vs10fdrasbf_tmp": "Floating Dragon - Dragon Boat Festival",
  "vswaysfltdrg_tmp": "Floating Dragon Hold & Spin Megaways",
  "vswaysfltdrgny_tmp": "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
  "vs10fdwhorses_tmp": "Floating Dragon Wild Horses",
  "vs10fdsnake_tmp": "Floating Dragon – Year of the Snake",
  "vs10fonzofff_tmp": "Fonzo’s Feline Fortunes",
  "vs20forge_tmp": "Forge of Olympus",
  "vs20forgewilds_tmp": "Forging Wilds",
  "vs1024fortune_tmp": "Fortune Ace",
  "vswaysfortsup_tmp": "Fortune Ace Super Scatter",
  "vs243fdragon_tmp": "Fortune Dragon",
  "vs40wildrun_tmp": "Fortune Hit’n Roll",
  "vswaysaztecgm_tmp": "Fortune of Aztec",
  "vs20amuleteg_tmp": "Fortune of Giza",
  "vs20olympgcl_tmp": "Fortune of Olympus",
  "vswaysstrlght_tmp": "Fortunes of Aztec",
  "vs20frankie_tmp": "Frightening Frankie",
  "vswaysfrbugs_tmp": "Frogs & Bugs",
  "vs10frontrun_tmp": "Front Runner Odds On",
  "vswaysftropics_tmp": "Frozen Tropics",
  "vs20fruitparty_tmp": "Fruit Party",
  "vs20fparty2_tmp": "Fruit Party 2",
  "vs20fpartydice_tmp": "Fruit Party Dice",
  "vs40frrainbow_tmp": "Fruit Rainbow",
  "vs20framazon_tmp": "Fruits of the Amazon",
  "vs20fortbon_tmp": "Fruity Treats",
  "vs1fufufu_tmp": "Fu Fu Fu",
  "vswaysbooboo_tmp": "Furry Bonanza Megaways",
  "vswaysfuryodin_tmp": "Fury of Odin Megaways",
  "vs20aztecgates_tmp": "Gates of Aztec",
  "vs20gatotgates_tmp": "Gates of Gatot Kaca",
  "vs20gatotx_tmp": "Gates of Gatot Kaca 1000",
  "vs20olgatssc_tmp": "Gates of Gatot Kaca Super Scatter",
  "vs20gtsofhades_tmp": "Gates of Hades",
  "vs20olympgate_tmp": "Gates of Olympus",
  "vs20olympx_tmp": "Gates of Olympus 1000",
  "vs20dicegatex_tmp": "Gates of Olympus 1000 Dice",
  "vs20olympdice_tmp": "Gates of Olympus Dice",
  "vs20olympgold_tmp": "Gates of Olympus Super Scatter",
  "vs20olympxmas_tmp": "Gates of Olympus Xmas",
  "vs20shmnarise_tmp": "Gates of Pyroth",
  "vs10runes_tmp": "Gates of Valhalla",
  "vs20gatotfury_tmp": "Gatot Kaca's Fury",
  "vs20clustext_tmp": "Gears of Horus",
  "vs20elevclust_tmp": "Gem Elevator",
  "vs20gemfirefor_tmp": "Gem Fire Fortune",
  "vs9gemtrio_tmp": "Gem Trio",
  "vs20goldfever_tmp": "Gems Bonanza",
  "vs20lcount_tmp": "Gems of Serengeti",
  "vs5gemstone_tmp": "Gemstone",
  "vs20gengembnz_tmp": "Genie’s Gem Bonanza",
  "vs20gobnudge_tmp": "Goblin Heist Powernudge",
  "vs10gizagods_tmp": "Gods of Giza",
  "vswaysincwnd_tmp": "Gold Oasis",
  "vs25goldparty_tmp": "Gold Party",
  "vs25goldpartya_tmp": "Gold Party 2 – After Hours",
  "vs25goldrush_tmp": "Gold Rush",
  "vs3train_tmp": "Gold Train",
  "vs25gldox_tmp": "Golden Ox",
  "vs25goldpig_tmp": "Golden Pig",
  "vs10luckfort_tmp": "Good Luck & Good Fortune",
  "vs1024gmayhem_tmp": "Gorilla Mayhem",
  "vs20olympgrace_tmp": "Grace of Ebisu",
  "vs20gravity_tmp": "Gravity Bonanza",
  "vs50grghsts_tmp": "Great Ghosts!",
  "vs25lagoon_tmp": "Great Lagoon",
  "vs25sea_tmp": "Great Reef",
  "vs20rhino_tmp": "Great Rhino",
  "vs20rhinoluxe_tmp": "Great Rhino Deluxe",
  "vswaysrhino_tmp": "Great Rhino Megaways",
  "vs10fortnpig_tmp": "Greedy Fortune Pig",
  "vs20wolfie_tmp": "Greedy Wolf",
  "vs243fortseren_tmp": "Greek Gods",
  "vs40hmrstrm_tmp": "Hammerstorm",
  "vs20midas2_tmp": "Hand of Midas 2",
  "vs10dmreels_tmp": "Happy Dragon",
  "vs20laughluck_tmp": "Happy Fortune",
  "vs20fishptrn_tmp": "Happy Nets",
  "vs20dhousehm_tmp": "Haunted Crypt",
  "vs20heartcleo_tmp": "Heart of Cleopatra",
  "vs25rio_tmp": "Heart of Rio",
  "vs20prizegrow_tmp": "Heartbreakers",
  "vs20hstgldngt_tmp": "Heist for the Golden Nuggets",
  "vs243nudge4gold_tmp": "Hellvis Wild",
  "vs20hercpeg_tmp": "Hercules and Pegasus",
  "vs50hercules_tmp": "Hercules Son of Zeus",
  "vs20shootstars_tmp": "Heroic Spins",
  "vs5himalaw_tmp": "Himalayan Wild",
  "vs88hockattack_tmp": "Hockey Attack",
  "vs576hokkwolf_tmp": "Hokkaido Wolf",
  "vs25holiday_tmp": "Holiday Ride",
  "vs20honey_tmp": "Honey Honey Honey",
  "vs9hotroll_tmp": "Hot Chilli",
  "vs25hotfiesta_tmp": "Hot Fiesta",
  "vs20dugems_tmp": "Hot Pepper",
  "vs25safari_tmp": "Hot Safari",
  "vs5hotburn_tmp": "Hot to Burn",
  "vs10hottb7fs_tmp": "Hot to Burn 7 Deadly Free Spins",
  "vs40hotburnx_tmp": "Hot To Burn Extreme",
  "vs20hburnhs_tmp": "Hot to Burn Hold and Spin",
  "vs5hotbmult_tmp": "Hot To Burn Multiplier",
  "vs10hottuna_tmp": "Hot Tuna",
  "vs100hsandks_tmp": "Hundreds and Thousands",
  "vs20stickypos_tmp": "Ice Lobster",
  "vs20popbottles_tmp": "Ice Mints",
  "vs20slightwdm_tmp": "Idol Pop Fever",
  "vs20thunder_tmp": "Inca Queen",
  "vs40infwild_tmp": "Infective Wild",
  "vs20irishcrown_tmp": "Irish Crown",
  "vs10jpblaze_tmp": "Jackpot Blaze",
  "vs20jhunter_tmp": "Jackpot Hunter",
  "vs1024butterfly_tmp": "Jade Butterfly",
  "vs10jnmntzma_tmp": "Jane Hunter and the Mask of Montezuma",
  "vs20mvwild_tmp": "Jasmine Dreams",
  "vs5jellyc_tmp": "Jelly Candy",
  "vs20payanyvol_tmp": "Jelly Express",
  "vs20jewelparty_tmp": "Jewel Rush",
  "vs10booklight_tmp": "John Hunter and Galileo’s Secrets",
  "vs10mayangods_tmp": "John Hunter And The Mayan Gods",
  "vs25scarabqueen_tmp": "John Hunter and the Tomb of the Scarab Queen",
  "vs25jokerking_tmp": "Joker King",
  "vs25jokrace_tmp": "Joker Race",
  "vs5jokerdice_tmp": "Joker's Jewel Dice",
  "vs5joker_tmp": "Joker's Jewels",
  "vs25jkrdaze_tmp": "Joker's Jewels Dazzle",
  "vs10jokerhot_tmp": "Joker's Jewels Hot",
  "vs5jjwild_tmp": "Joker's Jewels Wild",
  "vs5jokerjc_tmp": "Joker’s Jewels Cash",
  "vs5jokjewhs_tmp": "Joker’s Jewels Hold & Spin",
  "vs5jkrrevenge_tmp": "Joker’s Revenge",
  "vs25journey_tmp": "Journey to the West",
  "vs50juicyfr_tmp": "Juicy Fruits",
  "vs50jfmulthold_tmp": "Juicy Fruits Multihold",
  "vs20jjjack_tmp": "Jumbo Safari",
  "vs20gorilla_tmp": "Jungle Gorilla",
  "vs20speark_tmp": "King of Spear",
  "vs20asgard_tmp": "Kingdom of Asgard",
  "vs10kingofdth_tmp": "Kingdom of the Dead",
  "vs25spotz_tmp": "Knight Hot Spotz",
  "vs10cenrlgdevl_tmp": "Knights vs Barbarians",
  "vs243koipond_tmp": "Koi Pond",
  "vs20godiva_tmp": "Lady Godiva",
  "vs20lampinf_tmp": "Lamp Of Infinity",
  "vswaysrocktrls_tmp": "Launch to Riches",
  "vswayslavabls_tmp": "Lava Balls",
  "vswayslofhero_tmp": "Legend of Heroes Megaways",
  "vs20leprexmas_tmp": "Leprechaun Carol",
  "vs20leprechaun_tmp": "Leprechaun Song",
  "vs5littlegem_tmp": "Little Gem Hold and Spin",
  "vs20lobcrab_tmp": "Lobster Bob's Crazy Crab Shack",
  "vs20lobseafd_tmp": "Lobster Bob's Sea Food and Win It",
  "vs20lbstrhouse_tmp": "Lobster House",
  "vs20loksriches_tmp": "Loki's Riches",
  "vs5luckdce88_tmp": "Lucky Dice",
  "vs5luckydogly_tmp": "Lucky Dog",
  "vs1ball_tmp": "Lucky Dragon Ball",
  "vs50chinesecharms_tmp": "Lucky Dragons",
  "vswaysluckyfish_tmp": "Lucky Fishing Megaways",
  "vs5luckycol_tmp": "Lucky Fortune Tree",
  "vswayslight_tmp": "Lucky Lightning",
  "vs10forwildly_tmp": "Lucky Mouse",
  "vs25newyear_tmp": "Lucky New Year",
  "vs25tigeryear_tmp": "Lucky New Year - Tiger Treasures",
  "vs10fortnhsly_tmp": "Lucky Ox",
  "vs5lckpnd_tmp": "Lucky Panda",
  "vs5luckyphnly_tmp": "Lucky Phoenix",
  "vs5luckytigly_tmp": "Lucky Tiger",
  "vs5luckyt1kly_tmp": "Lucky Tiger 1000",
  "vs5luckytru_tmp": "Lucky Tiger Gold",
  "vs10luckcharm_tmp": "Lucky, Grace & Charm",
  "vs25luckwildpb_tmp": "Lucky’s Wild Pub",
  "vs25luckpub_tmp": "Lucky’s Wild Pub 2",
  "vs10madame_tmp": "Madame Destiny",
  "vswaysmadame_tmp": "Madame Destiny Megaways",
  "vs8magicjourn_tmp": "Magic Journey",
  "vs10mmm_tmp": "Magic Money Maze",
  "vs4096magician_tmp": "Magician's Secrets",
  "vs1024mahjpanda_tmp": "Mahjong Panda",
  "vs1024mahjwins_tmp": "Mahjong Wins",
  "vs1024mjwinbns_tmp": "Mahjong Wins Bonus",
  "vswaysmwss_tmp": "Mahjong Wins Super Scatter",
  "vswaysmajhng3p_tmp": "Mahjong Wins Triple Pot",
  "vs20mahjxbnz_tmp": "Mahjong X",
  "vs25goldrexp_tmp": "Majestic Express – Gold Run",
  "vs20mammoth_tmp": "Mammoth Gold Megaways",
  "vs9chen_tmp": "Master Chen's Fortune",
  "vs1mjokfp_tmp": "Master Gems",
  "vs1masterjoker_tmp": "Master Joker",
  "vs20medusast_tmp": "Medusa's Stone",
  "vswayslmm_tmp": "Meow Megaways",
  "vs20mmdtres_tmp": "Mermaid’s Treasure Trove",
  "vswaysmfreya_tmp": "Might of Freya Megaways",
  "vs50mightra_tmp": "Might of Ra",
  "vs50kingkong_tmp": "Mighty Kong",
  "vs20mmmelon_tmp": "Mighty Munching Melons",
  "vs20minerush_tmp": "Mining Rush",
  "vs20mochimon_tmp": "Mochimon",
  "vs20clreacts_tmp": "Moleionaire",
  "vs1money_tmp": "Money Money Money",
  "vs25mmouse_tmp": "Money Mouse",
  "vs20bblitz_tmp": "Money Stacks",
  "vs20msdice_tmp": "Money Stacks Dice",
  "vswaysbblitz_tmp": "Money Stacks Megaways",
  "vs9madmonkey_tmp": "Monkey Madness",
  "vs243mwarrior_tmp": "Monkey Warrior",
  "vs20superlanche_tmp": "Monster Superlanche",
  "vs1024moonsh_tmp": "Moonshot",
  "vswaysmrcursc_tmp": "Mr Null’s Wicked Wares",
  "vs20muertos_tmp": "Muertos Multiplier Megaways",
  "vswaysmjwl_tmp": "Mummy’s Jewels",
  "vswaysmjwl2_tmp": "Mummy’s Jewels 100",
  "vs25mustang_tmp": "Mustang Gold",
  "vswaysgoldcol_tmp": "Mustang Gold Megaways",
  "vs10trail_tmp": "Mustang Trail",
  "vs4096mystery_tmp": "Mysterious",
  "vs10wildtut_tmp": "Mysterious Egypt",
  "vs20powerwild_tmp": "Mystery Mice",
  "vswaysmorient_tmp": "Mystery of the Orient",
  "vswayswest_tmp": "Mystic Chief",
  "vs7fire88fp_tmp": "Mystic Wishes",
  "vs20nilefort_tmp": "Nile Fortune",
  "vs50northgard_tmp": "North Guardians",
  "vs20octobeer_tmp": "Octobeer Fortunes",
  "vswaysolwfp_tmp": "Olympus Wins",
  "vs10noodles_tmp": "Oodles of Noodles",
  "vs20oragold_tmp": "Oracle of Gold",
  "vs25pandatemple_tmp": "Panda Fortune 2",
  "vs25pandagold_tmp": "Panda's Fortune",
  "vs40pdmrsg_tmp": "Pandemic Rising",
  "vs10powerlines_tmp": "Peak Power",
  "vs25peking_tmp": "Peking Luck",
  "vs25xmasparty_tmp": "Penguins Christmas Party Time",
  "vswaystonypzz_tmp": "Peppe’s Pepperoni Pizza Plaza",
  "vs20phoenixf_tmp": "Phoenix Forge",
  "vs25pfarmfp_tmp": "Pig Farm",
  "vs9piggybank_tmp": "Piggy Bank Bills",
  "vs20piggybank_tmp": "Piggy Bankers",
  "vs20ltng_tmp": "Pinup Girls",
  "vs40pirate_tmp": "Pirate Gold",
  "vs40pirgold_tmp": "Pirate Gold Deluxe",
  "vs20mtreasure_tmp": "Pirate Golden Age",
  "vs9outlaw_tmp": "Pirates Pub",
  "vs50pixie_tmp": "Pixie Wings",
  "vswayspizza_tmp": "PIZZA PIZZA PIZZA",
  "vs20plantaliex_tmp": "Plants vs Aliens",
  "vs1dragon888_tmp": "Plushie Wins",
  "vswaysmegareel_tmp": "Pompeii Megareels Megaways",
  "vs20stckwldsc_tmp": "Pot of Fortune",
  "vswayspowzeus_tmp": "Power of Merlin Megaways",
  "vs20ninjapower_tmp": "Power of Ninja",
  "vswayshammthor_tmp": "Power of Thor Megaways",
  "vs20lvlup_tmp": "Pub Kings",
  "vs20pbonanza_tmp": "Pyramid Bonanza",
  "vs25pyramid_tmp": "Pyramid King",
  "vs10egrich_tmp": "Queen of Gods",
  "vs243queenie_tmp": "Queenie",
  "vs20goldclust_tmp": "Rabbit Garden",
  "vs243chargebull_tmp": "Raging Bull",
  "vswaysmltchmgw_tmp": "Raging Waterfall Megaways",
  "vs20rainbowg_tmp": "Rainbow Gold",
  "vs40rainbowr_tmp": "Rainbow Reels",
  "vs25rlbank_tmp": "Reel Banks",
  "vs20bison_tmp": "Release the Bison",
  "vs20kraken_tmp": "Release the Kraken",
  "vs20kraken2_tmp": "Release the Kraken 2",
  "vswayskrakenmw_tmp": "Release the Kraken Megaways",
  "vswaysresurich_tmp": "Resurrecting Riches",
  "vs10returndead_tmp": "Return of the Dead",
  "vswaysloki_tmp": "Revenge of Loki Megaways",
  "vs9ridelightng_tmp": "Ride The Lightning",
  "vs40stckwldlvl_tmp": "Ripe Rewards",
  "vs10nudgeit_tmp": "Rise of Giza PowerNudge",
  "vswayshexhaus_tmp": "Rise of Pyramids",
  "vs25samurai_tmp": "Rise of Samurai",
  "vs40samurai3_tmp": "Rise of Samurai 3",
  "vs15samurai4_tmp": "Rise of Samurai 4",
  "vswayssamurai_tmp": "Rise of Samurai Megaways",
  "vs4096robber_tmp": "Robber Strike",
  "vs20rockvegas_tmp": "Rock Vegas",
  "vswaysrockblst_tmp": "Rocket Blast Megaways",
  "vs20rnriches_tmp": "Rolling in Treasures",
  "vs20rujakbnz_tmp": "Rujak Bonanza",
  "vswayscashconv_tmp": "Running Sushi",
  "vs50safariking_tmp": "Safari King",
  "vs20saiman_tmp": "Saiyan Mania",
  "vs12scode_tmp": "Samurai Code",
  "vswayssanator_tmp": "Sanatorium Secrets",
  "vs20santa_tmp": "Santa",
  "vs20porbs_tmp": "Santa's Great Gifts",
  "vs20santawonder_tmp": "Santa's Wonderland",
  "vs20rainbowrsh_tmp": "Santa's Xmas Rush",
  "vs10santasl_tmp": "Santa’s Slay",
  "vs20dede_tmp": "Saray Ruyasi",
  "vswayssavlgnd_tmp": "Savannah Legend",
  "vswaysseastory_tmp": "Sea Fantasy",
  "vs25spgldways_tmp": "Secret City Gold",
  "vs20sparta_tmp": "Shield Of Sparta",
  "vs100sh_tmp": "Shining Hot 100",
  "vs20sh_tmp": "Shining Hot 20",
  "vs40sh_tmp": "Shining Hot 40",
  "vs5sh_tmp": "Shining Hot 5",
  "vs50jucier_tmp": "Sky Bounty",
  "vs25sleepdrag_tmp": "Sleeping Dragon",
  "vs20slmpop_tmp": "Slime Pop",
  "vs20smugcove_tmp": "Smugglers Cove",
  "vs10snakeeyes_tmp": "Snakes & Ladders - Snake Eyes",
  "vs10snakeladd_tmp": "Snakes and Ladders Megadice",
  "vs40spartaking_tmp": "Spartan King",
  "vs20splmystery_tmp": "Spellbinding Mystery",
  "vs10spellmastr_tmp": "Spellmaster",
  "vswaysfrywld_tmp": "Spin & Score Megaways",
  "vs10spiritadv_tmp": "Spirit of Adventure",
  "vswayshive_tmp": "Star Bounty",
  "vs10starpirate_tmp": "Star Pirates Code",
  "vs20schristmas_tmp": "Starlight Christmas",
  "vs20starlight_tmp": "Starlight Princess",
  "vs20starlightx_tmp": "Starlight Princess 1000",
  "vswaysjapan_tmp": "Starlight Princess Pachi",
  "vs20starprss_tmp": "Starlight Princess Super Scatter",
  "vswayssw_tmp": "Starlight Wins",
  "vs117649starz_tmp": "Starz Megaways",
  "vs10stmreels_tmp": "Steamin’ Reels",
  "vs20clustwild_tmp": "Sticky Bees",
  "vs10strawberry_tmp": "Strawberry Cocktail",
  "vs40streetracer_tmp": "Street Racer",
  "vs5strh_tmp": "Striking Hot 5",
  "vs20sugarrush_tmp": "Sugar Rush",
  "vs20sugarrushx_tmp": "Sugar Rush 1000",
  "vs20sugardice_tmp": "Sugar Rush Dice",
  "vs20sugrushss_tmp": "Sugar Rush Super Scatter",
  "vs20sugrux_tmp": "Sugar Rush Xmas",
  "vs20sugarnudge_tmp": "Sugar Supreme Powernudge",
  "vswaysmegwghts_tmp": "Sumo Supreme Megaways",
  "vs5super7_tmp": "Super 7s",
  "vs5supergummy_tmp": "Super Gummy Strike",
  "vs5spjoker_tmp": "Super Joker",
  "vs5tikistrike_tmp": "Super Tiki Strike",
  "vs20superx_tmp": "Super X",
  "vs20supermania_tmp": "Supermania",
  "vs10swbass_tmp": "Sweet Baklava",
  "vs20fruitsw_tmp": "Sweet Bonanza",
  "vs20fruitswx_tmp": "Sweet Bonanza 1000",
  "vs20swdicex_tmp": "Sweet Bonanza 1000 Dice",
  "vs20swbon2500_tmp": "Sweet Bonanza 2500",
  "vs20bnnzdice_tmp": "Sweet Bonanza Dice",
  "vs20swbonsup_tmp": "Sweet Bonanza Super Scatter",
  "vs20sbxmas_tmp": "Sweet Bonanza Xmas",
  "vs10luckybnz_tmp": "Sweet Burst",
  "vs20chestcol_tmp": "Sweet Craze",
  "vs20clustcol_tmp": "Sweet Kingdom",
  "vs20clspwrndg_tmp": "Sweet Powernudge",
  "vs20swrbon_tmp": "Sweet Rush Bonanza",
  "vs20swordofares_tmp": "Sword of Ares",
  "vs10diamondrgh_tmp": "Temple Guardians",
  "vs1024temuj_tmp": "Temujin Treasures",
  "vswaysalterego_tmp": "The Alter Ego",
  "vs20bigdawgs_tmp": "The Big Dawgs",
  "vs20bgdoghouse_tmp": "The Big Dog House",
  "vs20doghouse_tmp": "The Dog House",
  "vs20doghouse2_tmp": "The Dog House - Dog or Alive",
  "vs20dhsuper_tmp": "The Dog House - Royal Hunt",
  "vs20dhdice_tmp": "The Dog House Dice Show",
  "vswaysdogs_tmp": "The Dog House Megaways",
  "vs20doghousemh_tmp": "The Dog House Multihold",
  "vs20dhcluster2_tmp": "The Dog House – Muttley Crew",
  "vs1024dtiger_tmp": "The Dragon Tiger",
  "vs20chicken_tmp": "The Great Chicken Escape",
  "vs20stickysymbol_tmp": "The Great Stick-up",
  "vs20midas_tmp": "The Hand of Midas",
  "vs20sknights_tmp": "The Knight King",
  "vs20magicpot_tmp": "The Magic Cauldron",
  "vswaysmoneyman_tmp": "The Money Men Megaways",
  "vswaysredqueen_tmp": "The Red Queen",
  "vs25tigerwar_tmp": "The Tiger Warrior",
  "vs20tweethouse_tmp": "The Tweety House",
  "vs20ultim5_tmp": "The Ultimate 5",
  "vswayswildgang_tmp": "The Wild Gang",
  "vs40madwheel_tmp": "The Wild Machine",
  "vs10threestar_tmp": "Three Star Fortune",
  "vs10tictac_tmp": "Tic Tac Take",
  "vswaystimber_tmp": "Timber Stacks",
  "vs50fatfrogs_tmp": "Tiny Toads",
  "vs20theights_tmp": "Towering Fortunes",
  "vs18mashang_tmp": "Treasure Horse",
  "vs20trsbox_tmp": "Treasure Wild",
  "vs25tripleps_tmp": "Treasures of Osiris",
  "vs1fortunetree_tmp": "Tree of Riches",
  "vs20treesot_tmp": "Trees of Treasure",
  "vs5trdragons_tmp": "Triple Dragons",
  "vswaystrpgug_tmp": "Triple Pot Diamond",
  "vswaysasiatrzn_tmp": "Triple Pot Gold",
  "vs1tigers_tmp": "Triple Tigers",
  "vswaysjkrdrop_tmp": "Tropical Tiki",
  "vswaysraghex_tmp": "Tundra's Fortune",
  "vs5luckytwr_tmp": "Tut’s Treasure Tower",
  "vs20dhcluster_tmp": "Twilight Princess",
  "vs5ultrab_tmp": "Ultra Burn",
  "vs5ultradice_tmp": "Ultra Burn Dice",
  "vs5ultra_tmp": "Ultra Hold and Spin",
  "vs10vampwolf_tmp": "Vampires vs Wolves",
  "vswayswbounty_tmp": "Vampy Party",
  "vs20vegasmagic_tmp": "Vegas Magic",
  "vs25vegas_tmp": "Vegas Nights",
  "vs20sugarcoins_tmp": "Viking Forge",
  "vswaysvlcgds_tmp": "Volcano Goddess",
  "vs40voodoo_tmp": "Voodoo Magic",
  "vs20bigmass_tmp": "Waves of Poseidon",
  "vs5wfrog_tmp": "Wealthy Frog",
  "vs20multiup_tmp": "Wheel O'Gold",
  "vswayswildeq_tmp": "Wheel of Happiness",
  "vs20bchprty_tmp": "Wild Beach Party",
  "vs20stickywild_tmp": "Wild Bison Charge",
  "vs20wildboost_tmp": "Wild Booster",
  "vswaysrsm_tmp": "Wild Celebrity Bus Megaways",
  "vs40wanderw_tmp": "Wild Depths",
  "vs25gladiator_tmp": "Wild Gladiator",
  "vs20mparty_tmp": "Wild Hop & Drop",
  "vs20wildpix_tmp": "Wild Pixies",
  "vswayscyclop_tmp": "Wild Skullz",
  "vs25wildspells_tmp": "Wild Spells",
  "vs25walker_tmp": "Wild Walker",
  "vs20pistols_tmp": "Wild West Duels",
  "vs40wildwest_tmp": "Wild West Gold",
  "vs20wwgcluster_tmp": "Wild West Gold Blazing Bounty",
  "vswayswildwest_tmp": "Wild West Gold Megaways",
  "vswayswwhex_tmp": "Wild Wild Bananas",
  "vswayswwjoker_tmp": "Wild Wild Joker",
  "vswayspearls_tmp": "Wild Wild Pearls",
  "vs576treasures_tmp": "Wild Wild Riches",
  "vswayswwriches_tmp": "Wild Wild Riches Megaways",
  "vswayswwrichr_tmp": "Wild Wild Riches Returns",
  "vswaysbufstamp_tmp": "Wild Wildebeest Wins",
  "vs25wildies_tmp": "Wildies",
  "vs20procount_tmp": "Wisdom of Athena",
  "vs20procountx_tmp": "Wisdom of Athena 1000",
  "vs20procountxm_tmp": "Wisdom of Athena 1000 Xmas",
  "vswayswildbrst_tmp": "Witch Heart Megaways",
  "vs25wolfgold_tmp": "Wolf Gold",
  "vs25quadwolf_tmp": "Wolf Gold 4 Pack",
  "vs25ultwolgol_tmp": "Wolf Gold Ultimate",
  "vs20mkrush_tmp": "Wukong Rush",
  "vs20yotdk_tmp": "Year Of The Dragon King",
  "vs20mesmult_tmp": "Yeti Quest",
  "vs10piggybank_tmp": "You Can Piggy Bank On It",
  "vswaysyumyum_tmp": "Yum Yum Powerways",
  "vs15godsofwar_tmp": "Zeus vs Hades - Gods of War",
  "vs15zeushadseq_tmp": "Zeus vs Hades – Gods of War 250",
  "vswaysreelbtl_tmp": "Zeus vs Typhon",
  "vswayszombcarn_tmp": "Zombie Carnival",
  "vswayspompmr2_tmp": "Zombie School Megaways",
  "vs15seoultrain_tmp": "Zombie Train"
};

export { betinovioGameNameMapping };
export default betinovioGameNameMapping;
